var exports = {
  "k": "xa15a2ab7--974c16--container",
};

module.exports = exports;
